<div class="relation-container">
  <div class="left">
    <!-- 加载数据中... -->
    <nz-spin [nzSpinning]="leftLoading" nzTip="{{ 'house.house_relation.data_loading' | translate }}">
      <host-house-relation-left-panel
        #leftCMP
        (onUnlink)="onUnlink($event)"
        (onSave)="onSave()"
        (onCreate)="onCreate($event)"
        (onRefresh)="onRefresh($event)"
        (onTabChange)="onTypeTabChange.emit($event)"
      ></host-house-relation-left-panel>
    </nz-spin>
  </div>
  <div class="right">
    <!-- 加载数据中... -->
    <nz-spin [nzSpinning]="rightLoading" nzTip="{{ 'house.house_relation.data_loading' | translate }}">
      <host-house-relation-right-panel
        #rightCMP
        (onLink)="onLink($event)"
        (onSync)="onSync()"
        (onRefreshChannelHouses)="onRefreshChannelHouses($event)"
      ></host-house-relation-right-panel>
    </nz-spin>
  </div>
</div>
